export const currentState = {
  isAll: true,
  isByConcluded: false,
};
